import React, { useState } from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import TEST_ID from './index.testid';
import { navigate } from '@gatsbyjs/reach-router';
import { LINK_PREFIX } from '../..';
import OverviewListHeader from '~/components/molecule/OverviewListHeader';
import Dropdown from '~/components/molecule/Dropdown';
import ActionModal from './components/ActionModal';
import { type ActionType, actionOptions } from './constants';

const text = {
  title: 'Formulieren',
  addFormLabel: 'Nieuw formulier',
  importFormLabel: 'Formulier importeren',
  deleteAllForms: 'Delete all forms',
};

type Props = {
  limitedFormsToEnable: boolean;
  selectedItems: Array<string>;
  deselectAllItems: () => void;
  refreshData: () => Promise<void>;
};

const FormsToolbar: React.FCC<Props> = ({
  selectedItems,
  deselectAllItems,
  limitedFormsToEnable,
  refreshData,
}) => {
  const [actionType, setActionType] = useState<ActionType | null>(null);

  return (
    <>
      {actionType && (
        <ActionModal
          selectedItems={selectedItems}
          actionType={actionType}
          onClose={(hasUpdates: boolean) => {
            if (hasUpdates) {
              deselectAllItems();
              void refreshData();
            }
            setActionType(null);
          }}
        />
      )}
      <JustificationContainer
        align="start"
        justification="start"
        direction="column"
        width="100%"
      >
        <OverviewListHeader
          title={text.title}
          buttons={[
            {
              key: 'overview-header-add-form-button',
              node: (
                <Button
                  limited={limitedFormsToEnable}
                  size="medium"
                  label={text.addFormLabel}
                  icon="plus"
                  onClick={() => navigate(`${LINK_PREFIX}/wizard/`)}
                  dataTestId={TEST_ID.OVERVIEW_HEADER}
                />
              ),
            },
            {
              key: 'overview-header-import-form-button',
              node: (
                <Button
                  size="medium"
                  label={text.importFormLabel}
                  icon="plus"
                  ghost
                  appearance="secondary"
                  onClick={() => navigate(`${LINK_PREFIX}/import`)}
                  dataTestId={TEST_ID.OVERVIEW_HEADER}
                />
              ),
            },
          ]}
          extraButtons={[
            {
              key: 'forms-actions-dropdown',
              node: (
                <Dropdown
                  options={actionOptions}
                  onChange={({ option: { payload } }) => {
                    setActionType(payload);
                  }}
                  placeholder="Acties"
                  disabled={selectedItems.length === 0}
                />
              ),
            },
          ]}
        />
      </JustificationContainer>
    </>
  );
};

export default FormsToolbar;
